import {Analytics} from '../../lib/analytics/analytics';

export const analytics = new Analytics();

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const withAnalytics = analytics.withAnalytics.bind(analytics);
